<article
  [class]="`relative h-full text-[--color-text-primary] rounded-[--radius-3xl] ${cssClass()}`"
  [ngClass]="{
    'border border-solid border-[--color-border-primary] shadow-[0_4px_4px_0px_rgba(54,66,89,0.15)] ': isOfferBox(),
  }"
>
  <ng-content></ng-content>
</article>
